import AppConfig from '../appConfig';

const RECORD_TYPES = { housing_starts: 'housing', influencer_data: 'commercial' };
const MIN_ZOOM = 9;
const MAX_ZOOM = 14;

const tilesBase = () => `${AppConfig.constants.backends.sewebsite}/api/v1/development-sites/tiles/`;

export function applyDevelopmentSiteTiles(groups) {
    return groups.map(group => {
        const recordType = RECORD_TYPES[group && group.id];
        if (!recordType) return group;
        const sourceId = `development-sites-${recordType}`;
        return Object.assign({}, group, {
            sources: {
                [sourceId]: {
                    type: 'vector',
                    tiles: [`${tilesBase()}${recordType}/{z}/{x}/{y}`],
                    minzoom: MIN_ZOOM,
                    maxzoom: MAX_ZOOM,
                },
            },
            layers: group.layers.map(layer =>
                Object.assign({}, layer, {
                    source: sourceId,
                    'source-layer': layer['source-layer'].replace(/p$/, ''),
                }),
            ),
        });
    });
}

export function developmentSiteTileRequest(url) {
    return url.startsWith(tilesBase()) ? { url, credentials: 'include' } : undefined;
}
